module.exports = __webpack_public_path__ + "3a14e9c673283d2a9f18a75aa50fcf47.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo.png
// module id = 698
// module chunks = 0